
  
const initState = {
    companyUsers: [],
    page: 1,
    limit: 10,
    count: 0,
    user:null,
  };
  
  const CompanyUsersReducer = (state = initState, action) => {
    switch (action.type) {
      case 'SET_COMPANY_USERS':
        return {
          ...state,
          companyUsers: action.payload.data,
          page: action.payload.page,
          limit: action.payload.limit,
          count: action.payload.count
        };
      case 'RESET_STATE':
        return {
          ...state,
          ...initState
        };
        case 'SET_USER':
          return {
            ...state,
            user: action.payload.data,
          };
      default:
        return { ...state };
    }
  };
  
  export default CompanyUsersReducer;
  